interface FieldErrorProps {
  message?: string;
  id?: string;
  children?: React.ReactNode;
}

/** Inline validation message shown under a form control. */
export function FieldError({ message, id, children }: FieldErrorProps) {
  if (!message && !children) return null;
  return (
    <p id={id} className="mt-1 text-sm text-red-600" role="alert">
      {message}
      {children}
    </p>
  );
}
